import styles from './styles/SeverityBadge.module.scss';

import { Severity } from 'API';

interface Props {
    severity: Severity;
}

const SeverityBadge = ({ severity }: Props) => {
    switch (severity) {
        case Severity.FATAL:
            return (
                <span
                    data-testid='severity-badge'
                    className={`${styles.SeverityBadge} ${styles['SeverityBadge--fatal']} rioglyph rioglyph-remove-sign`}
                />
            );
        case Severity.ERROR:
            return (
                <span
                    data-testid='severity-badge'
                    className={`${styles.SeverityBadge} ${styles['SeverityBadge--error']} rioglyph rioglyph-error-sign`}
                />
            );
        case Severity.WARNING:
            return (
                <span
                    data-testid='severity-badge'
                    className={`${styles.SeverityBadge} ${styles['SeverityBadge--warning']} rioglyph rioglyph-warning-sign`}
                />
            );
        default:
            return null;
    }
};

export default SeverityBadge;
